/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { View } from "react-native";
import { TableCell, TableRow } from "@material-ui/core";
import Icon from "react-icons-kit";
import { circle } from "react-icons-kit/fa/circle";

import { Text, ExploreLink } from "UpduoLibrary";
import {
  skaleMainBlue,
  skaleWebTextGray,
  upduoLightestGray,
} from "config/UpduoColors";
import { getGraphColor } from "config/Utilities";

export default function BreakdownRow({
  itemType,
  item,
  data,
  fullDataQueryType,
  rowIndex,
}) {
  let link = "";
  if (itemType === "skills") {
    link = `/content/lesson/${item.id}`;
  } else {
    const itemType1 = itemType.slice(0, -1);
    link = `/dashboard/${itemType1}/${item.id}`;
  }
  let total = 0;
  const breakdownRows = data.map((item, itemIndex) => {
    total += item;
    let displayedValue = "";
    if (fullDataQueryType === "gp" || fullDataQueryType === "acc") {
      displayedValue = item ? `$${item.toFixed(2)}` : "";
    } else {
      displayedValue = item % 1 ? item.toFixed(1) : item;
    }
    return (
      <TableCell
        key={itemIndex}
        style={{ borderBottomColor: upduoLightestGray }}
      >
        <Text
          style={{
            color: skaleWebTextGray,
            fontSize: 14,
            display: "flex",
            justifyContent: "center",
          }}
        >
          {displayedValue}
        </Text>
      </TableCell>
    );
  });
  const unshiftKey = data.length;

  breakdownRows.unshift(
    <TableCell
      key={unshiftKey + 2}
      style={{ borderBottomColor: upduoLightestGray }}
    >
      <Text
        style={{
          fontSize: 14,
          color: skaleMainBlue,
          fontWeight: "bold",
          display: "flex",
          justifyContent: "center",
        }}
      >
        {total % 1 ? total.toFixed(1) : total}
      </Text>
    </TableCell>
  );

  breakdownRows.unshift(
    <TableCell
      key={unshiftKey + 1}
      style={{ borderBottomColor: upduoLightestGray }}
    >
      <View style={{ flexDirection: "row", alignItems: "center", width: 200 }}>
        <div
          style={{
            color: getGraphColor(item.name, rowIndex),
            paddingBottom: 2.5,
          }}
        >
          <Icon size={15} icon={circle} />
        </div>
        <View style={{ width: 10 }} />
        <ExploreLink text={item.name} to={link} />
      </View>
    </TableCell>
  );
  breakdownRows.unshift(
    <TableCell
      key={unshiftKey}
      style={{ borderBottomColor: upduoLightestGray }}
    >
      {rowIndex + 1}
    </TableCell>
  );

  return (
    <TableRow hover={true} key={rowIndex}>
      {breakdownRows}
    </TableRow>
  );
}
